/**
 * @generated SignedSource<<de9ab05a67f4725494bff35c3bdf0e78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoListItemHeaderWrapper_todo$data = {
  readonly createdAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly timeToResolvedFormatted: string | null;
  readonly " $fragmentType": "TodoListItemHeaderWrapper_todo";
};
export type TodoListItemHeaderWrapper_todo$key = {
  readonly " $data"?: TodoListItemHeaderWrapper_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemHeaderWrapper_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemHeaderWrapper_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "createdAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeToResolvedFormatted",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "82d8685338141b39c06b999fe71b0acd";

export default node;
